import UiIcon from './UiIcon';

// Reorganize only destinations already available to the role.
export function organizePerformanceNavigation(items) {
    const personalIds = ['self-assessment', 'activities', 'goals', 'peer-feedback', 'my-indicators'];
    const byId = id => items.find(item => item.id === id);
    const children = [byId('self-assessment'), byId('activities')].filter(Boolean).map(item => ({
        ...item, label: item.id === 'self-assessment' ? 'Core Responsibilities' : 'Additional Contributions',
    }));
    const performance = [
        ...(children.length ? [{ id: 'tasks-activities', label: 'Responsibilities & Contributions', icon: 'activity', aliases: children.map(item => item.id),
            badge: children.reduce((total, item) => total + (item.badge || 0), 0) }] : []),
        ...['goals', 'peer-feedback', 'my-indicators'].map(byId).filter(Boolean),
    ];
    return [
        ...items.filter(item => !personalIds.includes(item.id)).map(item => ({ ...item,
            section: ['routine', 'employee-evaluation'].includes(item.id) ? 'workflow'
                : item.id === 'teamdash' ? 'overview' : item.id === 'team' ? 'people' : item.section,
        })),
        ...performance.map(item => ({ ...item, section: 'performance' })),
    ];
}

export function isNavigationActive(item, active) {
    return item.id === active || Boolean(item.aliases?.includes(active)) || Boolean(item.children?.some(child => isNavigationActive(child, active)));
}

export function NavigationItem({ item, active, onNav }) {
    if (item.children?.length) return (
        <div className="cvi-navigation-parent" role="group" aria-label={item.label}>
            <div className={`cvi-navigation-parent-label${isNavigationActive(item, active) ? ' is-active' : ''}`}>
                <UiIcon name={item.icon} size={17} /><span>{item.label}</span>
            </div>
            <div className="cvi-navigation-children">
                {item.children.map(child => <NavigationItem key={child.id} item={child} active={active} onNav={onNav} />)}
            </div>
        </div>
    );
    return <button type="button" onClick={() => onNav(item.id)}
        className={`cvi-sidebar-item${isNavigationActive(item, active) ? ' is-active' : ''}`}
        aria-current={isNavigationActive(item, active) ? 'page' : undefined}>
        <span className="cvi-sidebar-icon" aria-hidden="true"><UiIcon name={item.icon} size={17} /></span>
        <span>{item.label}</span>
        {item.badge > 0 && <span className="cvi-sidebar-badge">{item.badge > 99 ? '99+' : item.badge}</span>}
    </button>;
}
